import { render } from "./StudentCoretimeDialog.vue?vue&type=template&id=536fe481&scoped=true"
import script from "./StudentCoretimeDialog.vue?vue&type=script&lang=js"
export * from "./StudentCoretimeDialog.vue?vue&type=script&lang=js"

import "./StudentCoretimeDialog.vue?vue&type=style&index=0&id=536fe481&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-536fe481"]])

export default __exports__